export default __webpack_public_path__ + "static/media/Industria Miradas Medellín 2026.482a5281.jpg";